import InscriptionManager from "./InscriptionManager";

export default InscriptionManager;
